import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cacc2c16"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cacc2c16')) {
      api.createRecord('cacc2c16', component.options)
    } else {
      api.reload('cacc2c16', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=cacc2c16", function () {
      api.rerender('cacc2c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contents/videoArchive/index.vue"
export default component.exports